import React from "react";
import { Route } from "react-router-dom";
import { URL } from "./url";
import LayoutRoot from "./layout/layout_root";
import HomeScreen from "../01_Home/home";
import DevScreen from "../99_Dev/dev";
import BranchScreen from "../03_Branch/01_Branch/branch";
import BookingScreen from "../03_Branch/02_Booking/booking";
import ConsultationScreen from "../03_Branch/03_Consultation/consultation";
// import HomeMainTain from "../02_Maintain_Page/home_maintain";

const RoutePublict = () => {
  // -------------------------- VAR --------------------------
  const language = "/:language";
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Route exact path={URL.home} element={<LayoutRoot />}>
      <Route index element={<HomeScreen />} />
      {/* <Route path={language} element={<HomeScreen />} />
      <Route index element={<BookingScreen />} /> */}
      <Route path={language} element={<BookingScreen />} />
      <Route path={URL.dev} element={<DevScreen />} />
      <Route path={URL.branch} element={<BranchScreen />} />
      <Route path={URL.branchBooking} element={<BookingScreen />} />
      <Route path={URL.consultation} element={<ConsultationScreen />} />
    </Route>
  );
};

export default RoutePublict;
